module.exports = __webpack_public_path__ + "static/media/crossing-road.06de8d3f.jpg";